export default __webpack_public_path__ + "static/media/first-aid-kit.3391d64d.png";